import React, { Component } from 'react'

export class Nosotros_Mision extends Component {
    render() {
        return (
            <div style={{padding: '3% 6%'}} >

                <h3 className="inicio-title">Misión</h3>
                <p>
                    Ser una ART Mutual que provea una cobertura sólida e integral a los trabajadores ante accidentes laborales y enfermedades profesionales llegando hasta las zonas más recónditas de todo el país, teniendo como fortaleza la prevención.<br/>
                </p><p/><p/>

                <h3 className="inicio-title">Visión</h3>
                <p>
                    Aspiramos a ser la ART Mutual Nº 1 del país, reconocida por la difusión de la cultura de la prevención, la confiabilidad de nuestros servicios y la reducción al mínimo de los accidentes laborales y de las enfermedades profesionales.<br/>
                </p> <p/><p/>

                <h3 className="inicio-title"> Valores</h3>
                <p>
                    •	Compromiso: con el trabajo orientado hacia el progreso permanente y la satisfacción de nuestros clientes.<br/>
                    •	Respeto: atendiendo con cortesía, actitud de servicio y eficiencia los requerimientos que nos sean solicitados.<br/>
                    •	Integridad: asumimos una conducta honesta, transparente, coherente y austera.<br/>
                    •	Eficiencia: hacemos las cosas de manera prolija y correcta.<br/>
                </p>
            </div>
        )
    }
}

export default Nosotros_Mision
